/**
 * Authentication Storage Utilities
 * Handles token storage in localStorage
 */

const TOKEN_KEY = "access_token";
const USER_DATA_KEY = "user_data";

export interface StoredUser {
  id: string;
  email: string;
  userName: string;
  role: string;
  isActive: boolean;
  dateCreated: string;
  isMasterAdmin: boolean;
  dateLastLoggedIn: string | null;
  passwordChangedAt: string | null;
}

export const getToken = (): string | null => {
  if (typeof window === "undefined") {
    return null;
  }
  return localStorage.getItem(TOKEN_KEY);
};

export const setToken = (token: string): void => {
  if (typeof window === "undefined") {
    return;
  }
  localStorage.setItem(TOKEN_KEY, token);
};

export const storeToken = (token: string): void => {
  setToken(token);
};

export const removeToken = (): void => {
  if (typeof window === "undefined") {
    return;
  }
  localStorage.removeItem(TOKEN_KEY);
};

export const storeUser = (user: StoredUser): void => {
  if (typeof window === "undefined") {
    return;
  }
  localStorage.setItem(USER_DATA_KEY, JSON.stringify(user));
};

export const getUser = (): StoredUser | null => {
  if (typeof window === "undefined") {
    return null;
  }
  const userData = localStorage.getItem(USER_DATA_KEY);
  if (!userData) return null;
  try {
    return JSON.parse(userData) as StoredUser;
  } catch {
    return null;
  }
};

export const removeUser = (): void => {
  if (typeof window === "undefined") {
    return;
  }
  localStorage.removeItem(USER_DATA_KEY);
};

export const isAuthenticated = (): boolean => {
  const token = getToken();
  const user = getUser();
  return !!token && !!user;
};

export const clearAllAuthData = (): void => {
  removeToken();
  removeUser();
};
